<template>
  <div>Iframe CRM MijnStalling.Online</div>
</template>
<script>
export default {
  
}
</script>